'use strict';

var FaresOptimizerUndoModalDirective = function FaresOptimizerUndoModalDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/fares-optimizer-undo-modal.html'),
    controller: 'FaresOptimizerUndoModalController',
    scope: {
      undoCallback: '=',
      showUndoModal: '=',
      stateChangeModal: '='
    },
    link: function link($scope, $element) {
      $scope.$watch('showUndoModal', function (newVal) {
        if (newVal) {
          $scope.selectedItemCount = $scope.stateChangeModal.count;
          $scope.handleUndoState();
          if ($scope.stateChangeModal.fareRecommendationUndoKeyList !== undefined) {
            $scope.fareRecommendationUndoKeyList = $scope.stateChangeModal.fareRecommendationUndoKeyList;
          }
          if ($scope.stateChangeModal.fareLadderUndoKeyList) {
            $scope.fareLadderUndoKeyList = $scope.stateChangeModal.fareLadderUndoKeyList;
          }
          $element.modal('show');
          $scope.showUndoModal = false;
        }
      });
    }
  };
};
FaresOptimizerUndoModalDirective.$inject = [];
module.exports = FaresOptimizerUndoModalDirective;